import { RTEContent } from 'module/ui/components/atoms/rich-text-editor-input/html-content';
import { FC } from 'react';
import { fragmentJSONToEditorContent } from 'components/organisms/document-editor/utils/node-utils';
import {
  SectionDescription,
  SectionPreview,
} from '../../../shared/section-styles';
import { TextBlockSectionComponentProps } from '../types';

interface Props extends TextBlockSectionComponentProps {
  onWrapperClick: () => void;
}
export const TextBlockSectionPromptPreview: FC<Props> = ({
  node,
  onWrapperClick,
}) => {
  return (
    <SectionPreview
      onClick={(event) => {
        event.stopPropagation();
        onWrapperClick();
      }}
    >
      <SectionDescription>
        <RTEContent
          value={fragmentJSONToEditorContent(node.attrs.config.content)}
        />
      </SectionDescription>
    </SectionPreview>
  );
};
